module.exports = "/assets/56cb1ceeaf4dd67b63746a28fe42be82.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WW.png
// module id = 1975
// module chunks = 0